/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const sendPushCampaignV1DataSchema = z.object({
  campaignId: z.number().int(),
  tokenCount: z.number().int(),
  okCount: z.number().int(),
  failedCount: z.number().int(),
  failures: z.array(z.object({ token: z.string(), error: z.string() })),
});

export type ISendPushCampaignV1Data = z.infer<typeof sendPushCampaignV1DataSchema>;

export const sendPushCampaignV1ResponseSchema = createApiResponseSchema(
  sendPushCampaignV1DataSchema,
) as z.ZodSchema<IAPI<ISendPushCampaignV1Data>>;

export type ISendPushCampaignV1Response = IAPI<ISendPushCampaignV1Data>;
